import React from "react";
import { COLORS } from "shared/consts";
import {IconProps} from './index.tsx';

export const Employees: React.FC<IconProps> = ({
                                               fill = COLORS.FG.SOFT,
                                               width = 24,
                                               height = 24,
                                               className,
                                           }) => {
    return (
        <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
             width={width} height={height} fill="none">
            <rect id="24 / Place / Figure man" width="24.000000" height="24.000000" x="0.000000" y="0.000000"/>
            <path id="Union"
                  d="M13.5 5C13.5 5.82843 12.8284 6.5 12 6.5C11.1716 6.5 10.5 5.82843 10.5 5C10.5 4.17157 11.1716 3.5 12 3.5C12.8284 3.5 13.5 4.17157 13.5 5ZM15 5C15 6.65685 13.6569 8 12 8C10.3431 8 9 6.65685 9 5C9 3.34315 10.3431 2 12 2C13.6569 2 15 3.34315 15 5ZM16.5 16L15 17L15 20C15 21.1046 14.1046 22 13 22L11 22C9.89543 22 9 21.1046 9 20L9 17L7.5 16L7.50941 11.993C7.51329 10.3389 8.85529 9 10.5094 9L13.5 9C15.1569 9 16.5 10.3431 16.5 12L16.5 16ZM9.83205 15.7519L9.00188 15.1985L9.0094 11.9965C9.01134 11.1694 9.68235 10.5 10.5094 10.5L13.5 10.5C14.3284 10.5 15 11.1716 15 12L15 15.1972L14.1679 15.7519L13.5 16.1972L13.5 17L13.5 20C13.5 20.2761 13.2761 20.5 13 20.5L11 20.5C10.7239 20.5 10.5 20.2761 10.5 20L10.5 17L10.5 16.1972L9.83205 15.7519Z"
                  fill={fill} fillRule="evenodd"/>
        </svg>
    );
};
